import Vue from 'vue'

Vue.config.productionTip = false

Vue.component('teacher-registration-component', require('./components/Form/TeacherRegistrationComponent.vue').default)

Vue.component('root-works-management-component', require('./components/PrivateArea/RootWorksManagementComponent.vue').default)
Vue.component('laboratories-request', require('./components/PrivateArea/LaboratoriesRequest.vue').default)

Vue.component('root-cinque-ragioni-per-component', require('./components/Cinque_ragioni_per/RootCinqueRagioniPerComponent.vue').default)

Vue.component('a-ogni-costo-component', require('./components/AOgniCosto/AOgniCostoComponent.vue').default)

Vue.component('gallery-component', require('./components/Gallery/GalleryComponent.vue').default)

Vue.component('guarda-che-marketing', require('./components/GuardaCheMarketing/GuardaCheMarketing.vue').default)

Vue.component('sai-cosa-fumi-component', require('./components/SaiCosaFumi/SaiCosaFumiComponent.vue').default)

new Vue({
	el: '#app'
})
